import { createSlice, createAsyncThunk, createEntityAdapter, PayloadAction } from '@reduxjs/toolkit';
import axios from '../utils/axios'


const initialState = {
    data: [],
    status: 'idle',
    calendar: []
};

export const getEvents = createAsyncThunk('/events/get', async () => {

    let res = axios.get('events',{
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch((err)=>{
        console.log(err)
        // setError(err.response.data.message)
      })
      
      
      const data = await res
      console.log(data);

      return data.data.data.News


    
})

export const createEvent = createAsyncThunk('/events/create', async (item) => {

  let res = axios.post('events', item,{
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }).catch((err)=>{
      console.log(err)
      // setError(err.response.data.message)
    })
    
    
    const data = await res
    // console.log(data);
    if(data.data.success){
      alert('Yangilik yaratildi')
    }

    // return data.data.data.News


  
})
// export const deleteEvent = createAsyncThunk('/events/delete', async (id) => {

//   let res = axios.delete(`news/${id}`,{
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem('token')}`
//       }
//     }).catch((err)=>{
//       console.log(err)
//       // setError(err.response.data.message)
//     })
    
    
//     const data = await res
//     console.log(data);
//     if(data.data.success){
//       alert("Yangilik o'chirildi")
//     }

//     // return data.data.data.News


  
// })

// export const editEvent = createAsyncThunk('/events/edit', async (item) => {

//   let res = axios.put(`news/${item._id}`, item.formData,{
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem('token')}`
//       }
//     }).catch((err)=>{
//       console.log(err)
//       // setError(err.response.data.message)
//     })
    
    
//     const data = await res
//     console.log(data);
//     if(data.data.success){
//       alert("Yangilik o'zgartirildi")
//     }

//     // return data.data.data.News


  
// })

const events = createSlice({
    name: 'projects',
    initialState,
    reducers: {
        getEventsCalendar(state, action) {

            state.calendar = state?.data?.map(item => {
   
             const date = item?.date.split("/")
             const day = date[0]
             const month = date[1]
             const year = date[2]
   
             return {title: item?.title_uz, start: `${year}-${month}-${day}T13:24:00`, end: `${year}-${month}-${day}T13:24:00`, allDay: false,backgroundColor: "blue", image: item?.image, text_en: item?.text_en, text_ru: item?.text_ru, text_uz: item?.text_uz, title_en: item?.title_en, title_ru: item?.title_ru }
           })
         }
    },
    extraReducers(builder) {
      builder
      .addCase(getEvents.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(getEvents.rejected, (state, action) => {
        state.status = 'failed'
      })
      .addCase(getEvents.fulfilled,(state, action) => {
        // state.status = "idle";
        state.data = action.payload;
        state.status = 'succeeded'
      })
      .addCase(createEvent.fulfilled,(state, action) => {
        // state.status = "idle";
        state.status = 'idle'
      })
    //   .addCase(deleteEvent.fulfilled,(state, action) => {
    //     // state.status = "idle";
    //     state.status = 'idle'
    //   })
    //   .addCase(editEvent.fulfilled,(state, action) => {
    //     // state.status = "idle";
    //     state.status = 'idle'
    //   })
      }
  });
  export const {getEventsCalendar} = events.actions
export const reducer = events.reducer;